/** Every tag the markets API can send, including ones never surfaced in the UI. */
export enum TokenListTag {
    Featured = "Featured",
    Native = "Native",
    Stables = "Stables",
    Bridged = "Bridged",
    LST = "LST",
    LRT = "LRT",
    Memes = "Memes",
    Governance = "Governance",
    Staked = "Staked",
    RWA = "RWA",
    Utility = "Utility",
    Misc = "Misc",
    DeFi = "DeFi",
    Treasuries = "Treasuries",
    LP = "LP",
    xStock = "xStock",
    Vault = "Vault",
    Lockbox = "Lockbox",
    Commodity = "Commodity",
    PrivateCredit = "Private Credit",
    Collectibles = "Collectibles",
    Tickets = "Tickets",
    DePIN = "DePIN",
    Nft = "nft",
    MarketHours = "Market Hours",
    AllowStalePrice = "Allow Stale Price",
    /** Listed only for wallets that hold it (private deal NFTs). */
    WalletOnly = "Wallet Only"
}

/** Tags shown to users as categories. Excludes classification/behavior flags. */
export const UI_TOKEN_LIST_TAGS = [
    TokenListTag.Featured,
    TokenListTag.Native,
    TokenListTag.Stables,
    TokenListTag.Bridged,
    TokenListTag.LST,
    TokenListTag.LRT,
    TokenListTag.Memes,
    TokenListTag.Governance,
    TokenListTag.Staked,
    TokenListTag.RWA,
    TokenListTag.Utility,
    TokenListTag.Misc,
    TokenListTag.DeFi,
    TokenListTag.Treasuries,
    TokenListTag.LP,
    TokenListTag.xStock,
    TokenListTag.Vault,
    TokenListTag.Lockbox,
    TokenListTag.Commodity,
    TokenListTag.PrivateCredit,
    TokenListTag.Collectibles,
    TokenListTag.Tickets,
    TokenListTag.DePIN
] as const satisfies readonly TokenListTag[];

export type UiTokenListTag = (typeof UI_TOKEN_LIST_TAGS)[number];

const UI_TOKEN_LIST_TAG_SET = new Set<TokenListTag>(UI_TOKEN_LIST_TAGS);

export function isUiTokenListTag(tag: TokenListTag): tag is UiTokenListTag {
    return UI_TOKEN_LIST_TAG_SET.has(tag);
}

export enum VaultMetadataTag {
    UrlAccessOnly = "urlAccessOnly",
    Popular = "popular",
    Featured = "featured",
    Stablecoins = "stablecoins",
    SOL = "sol",
    LP = "lp",
    BTC = "btc",
    Genesis = "genesis",
    RWA = "rwa",
    Collateral = "collateral",
    ComingSoon = "comingSoon",
    YieldOptimizer = "yieldOptimizer"
}

/** Tags that classify earn vault strategies (subset of {@link VaultMetadataTag}). */
export const EARN_STRATEGY_VAULT_METADATA_TAGS = [
    VaultMetadataTag.YieldOptimizer
] as const satisfies readonly VaultMetadataTag[];

export type EarnStrategyVaultMetadataTag = (typeof EARN_STRATEGY_VAULT_METADATA_TAGS)[number];
